var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-table',{staticClass:"rounded-table",attrs:{"items":_vm.items,"fields":_vm.computedFields,"responsive":"sm","striped":"","bordered":"","hover":"","outlined":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }